export const hasAnyVolDiscApplied = (isAppliedIndex) =>
    isAppliedIndex?.length > 0 && isAppliedIndex?.some((item) => item?.apply === true);

export const noneVolDiscApplied = (isAppliedIndex) =>
    isAppliedIndex?.length > 0 && isAppliedIndex?.every((item) => item?.apply === false);
